import classNames from "classnames";
import { useState, useEffect } from "react";
import {
    GetFormById,
    submitCartCustomForm
} from "../../Action";
import { toast } from "react-toastify";
import DynamicField from "./DynamicField";

const validateFields = (fields, values) => {
    const errors = {};
    fields.forEach((f) => {
        const { properties = {} } = f;
        if (!properties.required || properties.hidden) return;
        const v = values[f.name];
        if (v === undefined || v === null || v === "") {
            errors[f.name] = `${properties.label || "This field"} is required.`;
            return;
        }
        if (f.type === "email" || f.FieldType === "Email") {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!re.test(String(v))) {
                errors[f.name] = "Please enter a valid email address.";
            }
        }
        if (f.FieldType === "ContactNumber" || f.type === "number") {
            const digits = String(v).replace(/\D/g, "");
            if (digits.length < 6) {
                errors[f.name] = "Please enter a valid number.";
            }
        }
    });
    return errors;
};

const GeneratedCustomForm = (dataprops) => {
    const { Submitfunction, formId } = dataprops;
    const [cartDownloadSubmitDisabled, setcartDownloadSubmitDisabled] = useState(false);
    const [FormJSON, setFormJSON] = useState(null);
    const [formLoading, setFormLoading] = useState(true);
    const [formValues, setFormValues] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                setFormLoading(true);
                const res = await GetFormById(formId);
                if (cancelled) return;
                const fields = Array.isArray(res) ? res : res?.data || [];
                setFormJSON(fields);

                // initialise values
                const initial = {};
                fields.forEach((f) => {
                    initial[f.name] = f?.type === "checkbox" ? false : "";
                });
                setFormValues(initial);
            } catch (err) {
                console.error("GetFormById failed", err);
            } finally {
                if (!cancelled) setFormLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [formId]);

    const handleFieldChange = (name, value) => {
        setFormValues((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((prev) => {
                const next = { ...prev };
                delete next[name];
                return next;
            });
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!FormJSON || FormJSON.length === 0) return;
        const validationErrors = validateFields(FormJSON, formValues);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});

        setcartDownloadSubmitDisabled(true);

        const payload = formValues

        try {
            const res = await submitCartCustomForm(payload, formId);
            if (res?.status) {
                await Submitfunction(res);
            }else{
                toast.error(
                    res?.message || "Something went wrong."
                );
            }
        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.message || error?.message || "Something went wrong."
            );
        } finally {
            setcartDownloadSubmitDisabled(false);
        }
    };

    return (
        <div className="popup-body">
            <div className="popup-content">
                <div className="row">
                    <div className="column">
                        {formLoading ? (
                            <div className="spinnerBg">
                                <div className="bt-spinner"></div>
                            </div>
                        ) : !FormJSON || FormJSON.length === 0 ? (
                            <p className="textDanger">Unable to load form.</p>
                        ) : (
                            <form
                                className="download-pdf-form cart-download"
                                onSubmit={handleSubmit}
                            >
                                {FormJSON.map((field) => (
                                    <DynamicField
                                        key={field.name}
                                        field={field}
                                        value={formValues[field.name]}
                                        error={errors[field.name]}
                                        onChange={handleFieldChange}
                                    />
                                ))}

                                {cartDownloadSubmitDisabled ? (
                                    <div className="spinnerBg">
                                        <div className="bt-spinner"></div>
                                    </div>
                                ) : (
                                    <button
                                        className={`${classNames({})} btn`}
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                )}
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GeneratedCustomForm;
